export const TYPECIRCLARS = `/v2/guest/regulations?model=law`;
export const CIRCLARS = (id) => `/v2/guest/regulations/${id}?model=law`;
